/**
 * VersionBadge — exibe versão do release na sidebar.
 *
 * Suporta três variantes:
 *   - 'default' : release limpo    → "v0.0.8 · abc1234"
 *   - 'hotfix'  : N commits extras  → "v0.0.8 (hotfix.3) · abc1234"
 *   - 'dev'     : build local/dev   → "dev · local"
 *
 * collapsed=true mostra apenas os 4 primeiros chars do commit (ou "dev").
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { parseVersionInfo, type VersionInfo } from './version-badge.utils';
export type { VersionInfo } from './version-badge.utils';

export interface VersionBadgeProps {
  /** Sidebar colapsada → mostra apenas displayShort */
  collapsed?: boolean;
}

// ---------------------------------------------------------------------------
// Color map
// ---------------------------------------------------------------------------

const variantClass: Record<VersionInfo['variant'], string> = {
  default: 'text-zinc-400 dark:text-zinc-600',
  hotfix: 'text-orange-400 dark:text-orange-500',
  dev: 'text-amber-400 dark:text-amber-500',
};

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export const VersionBadge: React.FC<VersionBadgeProps> = ({ collapsed = false }) => {
  const info = parseVersionInfo({
    VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
    VITE_GIT_COMMIT: import.meta.env.VITE_GIT_COMMIT,
    VITE_RELEASE_BRANCH: import.meta.env.VITE_RELEASE_BRANCH,
  });

  return (
    <span
      data-testid="version-badge"
      className={cn('select-none text-[10px]', variantClass[info.variant])}
    >
      {collapsed ? info.displayShort : info.displayFull}
    </span>
  );
};
